(function(){
  // 2026-10-16: no dash in the error message (house rule), and the button words follow the page language
  var AR=(document.documentElement.getAttribute('lang')||'').toLowerCase().indexOf('ar')===0;
  var T=AR?{adding:'جارٍ الإضافة',added:'تمت الإضافة',add:'+ أضف',bag:'أُضيف إلى سلتك',fail:'تعذّرت الإضافة. حاول مرة أخرى.',addingAll:'جارٍ الإضافة…',allAdded:'أُضيف الكل'}
          :{adding:'Adding',added:'Added',add:'+ Add',bag:'Added to your bag',fail:'Could not add. Please try again.',addingAll:'Adding…',allAdded:'All added'};
  function init(){
    var root=document.getElementById('prt');
    if(!root||root.dataset.loaded) return;
    var url=root.getAttribute('data-url'); if(!url) return;
    root.dataset.loaded='1';
    fetch(url,{headers:{'Accept':'text/html'}})
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var rows=doc.querySelectorAll('.prt__row, .prt__all');
        var box=document.getElementById('prt-rows');
        if(!rows.length||!box) return;
        rows.forEach(function(n){ box.appendChild(n); });
        root.hidden=false;
      })
      .catch(function(){});
  }
  function bubble(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(c){
        document.querySelectorAll('.cart-bubble').forEach(function(b){
          b.classList.remove('visually-hidden');
          var n=b.querySelector('.cart-bubble__text-count');
          if(n){ n.classList.remove('hidden'); n.textContent=c.item_count; }
        });
      }).catch(function(){});
  }
  function msg(t,err){
    var m=document.getElementById('prt-msg'); if(!m) return;
    if(err){ m.setAttribute('data-err','1'); } else { m.removeAttribute('data-err'); }
    m.textContent=t;
  }
  function add(btn){
    var id=btn.getAttribute('data-vid');
    if(!id||btn.hasAttribute('data-done')) return Promise.resolve();
    btn.disabled=true; btn.textContent=T.adding;
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(id),quantity:1}]})})
      .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
      .then(function(){ btn.setAttribute('data-done','1'); btn.textContent=T.added; btn.disabled=false;
        msg(T.bag,false); bubble(); })
      .catch(function(){ btn.disabled=false; btn.textContent=T.add;
        msg(T.fail,true); });
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest && e.target.closest('.prt__add');
    if(a){ e.preventDefault(); add(a); return; }
    var all=e.target.closest && e.target.closest('.prt__all');
    if(all){
      e.preventDefault();
      var btns=[].slice.call(document.querySelectorAll('.prt__add:not([data-done])'));
      all.disabled=true; all.textContent=T.addingAll;
      btns.reduce(function(p,b){ return p.then(function(){ return add(b); }); },Promise.resolve())
        .then(function(){ all.textContent=T.allAdded; });
    }
  });
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',init); } else { init(); }
})();